<button [id]="column.name" class="trigger-button" mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="showEditInput($event)" *ngIf="column.selfDefined">
    <span>
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.EDIT_COLUMN.EDIT_COLUMN_NAMES' | translate }}
    </span>
  </button>
  <button mat-menu-item (click)="openSortOrderModal()">
    <span>
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.EDIT_COLUMN.SET_SORT_ORDER' | translate }}
    </span>
  </button>
  <button
    *ngIf="column.selfDefined"
    mat-menu-item
    [viConfirm]="{
      title: '+INSTALLATIONS.KANBAN_DASHBOARD.DELETE_COLUMN.MODAL_HEADER' | translate,
      content: '+INSTALLATIONS.KANBAN_DASHBOARD.DELETE_COLUMN.MODAL_CONTENT' | translate,
      cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
      confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
    }"
    gtm="onOpen"
    gtmAction="Dashboard delete column attempt"
    gtmCategory="Delete dashboard column"
    (confirm)="deleteColumn()"
  >
    <span>
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.EDIT_COLUMN.DELETE_COLUMN' | translate }}
    </span>
  </button>
</mat-menu>
